(function () {
  // Bypasses Dawn's own quick-add (modal-opener / <product-form>) for
  // the cart drawer's "You might also like" row — that flow has a
  // fallback that redirects to /cart when it can't resolve a
  // cart-drawer/cart-notification reference, which is what was
  // happening here (nested inside the drawer itself). This does a
  // plain, direct add of the product's first available variant via
  // the Cart AJAX API, then republishes the same cartUpdate event
  // Dawn's own add-to-cart flow uses — cart-drawer-items already
  // subscribes to that event and refreshes itself, so the drawer
  // updates the exact same way it would from a normal add.
  function handleClick(event) {
    var button = event.currentTarget;
    if (button.disabled) return;

    var variantId = button.dataset.variantId;
    if (!variantId) return;

    button.disabled = true;

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || 'Could not add to cart');
          return data;
        });
      })
      .then(function (data) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-drawer-upsell',
            productVariantId: variantId,
            cartData: data,
          });
        }
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        button.disabled = false;
      });
  }

  function init() {
    document.querySelectorAll('.cart-drawer__upsell-add').forEach(function (button) {
      if (button.dataset.upsellBound) return;
      button.dataset.upsellBound = 'true';
      button.addEventListener('click', handleClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The drawer's contents get swapped wholesale on cart updates
  // (Dawn's own onCartUpdate replaces the whole cart-drawer-items /
  // .cart-drawer__footer nodes), so newly-rendered upsell buttons
  // need their listeners re-attached after each refresh.
  document.addEventListener('cart:refresh', init);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(init, 0);
    });
  }
})();
